var map = {
	"./en": [
		17756,
		"src_locale_en_ts"
	],
	"./en.ts": [
		17756,
		"src_locale_en_ts"
	],
	"./it": [
		85396,
		"src_locale_it_ts"
	],
	"./it.ts": [
		85396,
		"src_locale_it_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 54887;
module.exports = webpackAsyncContext;